
import {
  IClientOptions,
} from 'mqtt'

export const OPTIONS: IClientOptions = {
  clean: true, // true: clear session, false: keep session
  connectTimeout: 10000, // mqtt connect timeout
  resubscribe: true, // resubscribe to previous topics after reconnect
  reconnectPeriod: 10000, // reconnect interval
  keepalive: 1, // heartbeat interval: 1s
}
